import React from 'react';
import {Layout} from 'components/layout';
import {ToolBar} from 'components/toolbar';

type Props = {
  onClose: () => void;
};

export const SearchToolbar: React.FC<Props> = ({onClose}) => {
  return (
    <Layout horizontal adjustCenter adjustRight flex={1}>
      <ToolBar>
        <ToolBar.IconTool icon="Close" onClick={onClose} />
      </ToolBar>
    </Layout>
  );
};
